export function isBrowserNotificationSupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window
}

export function getNotificationPermission(): NotificationPermission | 'unsupported' {
  if (!isBrowserNotificationSupported()) return 'unsupported'
  return Notification.permission
}

export async function requestNotificationPermission(): Promise<NotificationPermission | 'unsupported'> {
  if (!isBrowserNotificationSupported()) return 'unsupported'
  if (Notification.permission === 'granted') return 'granted'
  if (Notification.permission === 'denied') return 'denied'
  try {
    return await Notification.requestPermission()
  } catch {
    return 'denied'
  }
}

export type ShowNotificationOptions = {
  title: string
  body: string
  tag?: string
  onClick?: () => void
}

/** Returns false if notification could not be shown. */
export function showBrowserNotification(opts: ShowNotificationOptions): boolean {
  if (!isBrowserNotificationSupported() || Notification.permission !== 'granted') return false
  try {
    const n = new Notification(opts.title, {
      body: opts.body,
      tag: opts.tag,
      icon: '/favicon.ico',
    })
    n.onclick = () => {
      window.focus()
      opts.onClick?.()
      n.close()
    }
    return true
  } catch {
    return false
  }
}

const STORAGE_PREFIX = 'panel_pending_notify_enabled_'

export function getPendingNotifyEnabled(tokenId: number): boolean {
  try {
    return localStorage.getItem(`${STORAGE_PREFIX}${tokenId}`) === '1'
  } catch {
    return false
  }
}

export function setPendingNotifyEnabled(tokenId: number, enabled: boolean): void {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${tokenId}`, enabled ? '1' : '0')
  } catch {
    // ignore quota errors
  }
}
